import { render, staticRenderFns } from "./BizcircleTag.vue?vue&type=template&id=b1d24d5c&scoped=true&"
import script from "./BizcircleTag.vue?vue&type=script&lang=js&"
export * from "./BizcircleTag.vue?vue&type=script&lang=js&"
import style0 from "./BizcircleTag.vue?vue&type=style&index=0&id=b1d24d5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1d24d5c",
  null
  
)

export default component.exports